export default __webpack_public_path__ + "static/media/GPS_08.dc556ac6.png";